import React, { useEffect } from 'react';
import ReactWhatsapp from 'react-whatsapp';
import WhatsAppIcon from './../assets/icons/whatsapp.svg';
import { graphql, Link, useStaticQuery } from 'gatsby';

export const WHATSAPP_QUERY = graphql`
  query WhatsappQuery {
    datoCmsWhatappText {
      text
    }
  }
`;

const Messenger = () => {
  const data = useStaticQuery(WHATSAPP_QUERY);

  const text = data?.datoCmsWhatappText?.text ?? '';
  // useEffect(() => {
  //     const chatbox = document.getElementById('fb-customer-chat');
  //     chatbox.setAttribute("page_id", "107565901566299");
  //     chatbox.setAttribute("attribution", "biz_inbox");

  //     window.fbAsyncInit = function() {
  //         FB.init({
  //             xfbml            : true,
  //             version          : 'v12.0'
  //         });
  //     };

  //     (function(d, s, id) {
  //         let js, fjs = d.getElementsByTagName(s)[0];
  //         if (d.getElementById(id)) return;
  //         js = d.createElement(s); js.id = id;
  //         js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
  //         fjs.parentNode.insertBefore(js, fjs);
  //     }(document, 'script', 'facebook-jssdk'));
  // });

  return (
    <div className="whatsapp-floater">
      <a
        className="whatsapp-floating-button"
        href={`https://wa.me/447704004444?text=${encodeURIComponent(
          'Hi there, I am getting in touch via MyMathsCloud.com',
        )}`}
      >
        <img src={WhatsAppIcon} />
      </a>
      {text && <div className="whatsapp-text">{text}</div>}
    </div>
    //   <div id="fb-root"></div>
    //   <div id="fb-customer-chat" className="fb-customerchat"></div>
  );
};

export { Messenger };
